/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PreOpsQuestionKind } from './PreOpsQuestionKind';
import {
    PreOpsQuestionKindFromJSON,
    PreOpsQuestionKindFromJSONTyped,
    PreOpsQuestionKindToJSON,
    PreOpsQuestionKindToJSONTyped,
} from './PreOpsQuestionKind';

/**
 * 
 * @export
 * @interface PreOpsQuestion
 */
export interface PreOpsQuestion {
    /**
     * 
     * @type {string}
     * @memberof PreOpsQuestion
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof PreOpsQuestion
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PreOpsQuestion
     */
    updatedAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsQuestion
     */
    deleted: boolean;
    /**
     * This field restricts [`PreOpsAnswer.choice`](crate::schemas::pre_ops_answers::PreOpsAnswer#structfield.choice).
     * @type {PreOpsQuestionKind}
     * @memberof PreOpsQuestion
     */
    kind: PreOpsQuestionKind;
    /**
     * This is the time at which this question has been pulled from the database. This timestamp is needed to reconstruct the list of questions at this point of time. Without this, it's impossible to ensure that all questions of a checklist have been answered.
     * @type {Date}
     * @memberof PreOpsQuestion
     */
    pulledAt: Date;
    /**
     * 
     * @type {string}
     * @memberof PreOpsQuestion
     */
    body: string;
    /**
     * 
     * @type {number}
     * @memberof PreOpsQuestion
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof PreOpsQuestion
     */
    versionId: string;
    /**
     * 
     * @type {string}
     * @memberof PreOpsQuestion
     */
    checklistId: string;
}



/**
 * Check if a given object implements the PreOpsQuestion interface.
 */
export function instanceOfPreOpsQuestion(value: object): value is PreOpsQuestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('pulledAt' in value) || value['pulledAt'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('versionId' in value) || value['versionId'] === undefined) return false;
    if (!('checklistId' in value) || value['checklistId'] === undefined) return false;
    return true;
}

export function PreOpsQuestionFromJSON(json: any): PreOpsQuestion {
    return PreOpsQuestionFromJSONTyped(json, false);
}

export function PreOpsQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsQuestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'deleted': json['deleted'],
        'kind': PreOpsQuestionKindFromJSON(json['kind']),
        'pulledAt': (new Date(json['pulledAt'])),
        'body': json['body'],
        'position': json['position'],
        'versionId': json['versionId'],
        'checklistId': json['checklistId'],
    };
}

export function PreOpsQuestionToJSON(json: any): PreOpsQuestion {
    return PreOpsQuestionToJSONTyped(json, false);
}

export function PreOpsQuestionToJSONTyped(value?: PreOpsQuestion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'deleted': value['deleted'],
        'kind': PreOpsQuestionKindToJSON(value['kind']),
        'pulledAt': value['pulledAt'].toISOString(),
        'body': value['body'],
        'position': value['position'],
        'versionId': value['versionId'],
        'checklistId': value['checklistId'],
    };
}

